<template lang="pug">
  .resource-view-wrapper(:class="'context-' + context")
    include DashboardIndex.pug
</template>

<script>
import Api from "@/components/services/Api";
import Notification from "./Notification";
import Announcement from "./Announcement";
import DashboardCard from "./DashboardCard";
import { mapState } from 'vuex';

export default {
  name: 'DashboardIndex',
  components: {Notification, Announcement, DashboardCard},
  computed: mapState([
    "context",
  ]),
  data() {
    return {
      user: null,
      visible: false,
      announcements: [],
      notifications: [],
      completeness: null,
      progressColor: "red",
    }
  },
  created() {
    const _this = this;

    Api.me(this.$store.state.token).then(result => {
      let hasLopd = result.data.lopd

      if (hasLopd) {
        // If it is not a professional we must redirect to school
        _this.user = result.data;
        _this.announcements = result.data.announcements
        _this.notifications = result.data.notifications
        _this.completeness = result.data.completeness
        _this.visible = true;

        // Decide class wrapper
        if (_this.completeness < 50) {
          this.progressColor = "#b71c1c"
        } else if (_this.completeness <= 75) {
          this.progressColor = "#fecc39"
        } else {
          this.progressColor = "#7ea4b3"
        }
      } else {
        _this.$router.push({
          name: "Lopd",
        });
      }
    }).catch(err => {
      // TODO: Manage error
    });
  }
}

</script>

<style scoped lang="scss">
@import "./../../variables";
@import "Dashboard";
@import "DashboardIndex";
@import "./../../styles/bars"


</style>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardIndex.vue